import * as Constants from './Constants'

export class ConstantsParser {
  constructor(constants, device = null) {
    this.device = device
    this.constants = constants
    this.initClasses(this.constants)
  }

  initClasses(constants) {
    if(Object.prototype.hasOwnProperty.call(constants, 'desktop')) {
      constants = Object.keys(constants)
        .reduce( (carry, device) => {
          return carry = [...carry, ...constants[device]]
        }, [])
        .filter( (constant, index, self) => self.indexOf(constant) === index)
    }

    constants.map(constant => `${constant.property}Classes`)
      .forEach(constant => this[constant] = Constants[constant])
  }

  parse() {
    if (! this.device) {
      return this.parseClasses()
    }
    if (this.device == 'desktop') {
      return this.parseResponsiveClasses()
    }
    return this.parseDeviceClasses()
  }

  parseClasses() {
    let constants = new Object
    this.constants.forEach(constant => constants = {...constants, ...this[`${constant.property}Classes`]})
    return this.constants.map(constant => constant.value).map(constant => constants[constant]).flat(1)
  }

  parseDeviceClasses() {
    let constants = new Object
    this.constants[this.device].forEach(constant => constants = {...constants, ...this[`${constant.property}Classes`]})
    return this.constants[this.device].map(constant => constant.value).map(constant => constants[constant]).flat(1)
  }

  parseResponsiveClasses() {
    let constants = new Object
    Object.keys(this.constants).forEach(device => {
      this.constants[device].forEach(constant => {
        constants = {...constants, ...this[`${constant.property}Classes`]}
      })
    })

    let classes = Object.keys(this.constants).map(constant => {
      if (constant == 'desktop') {
        return this.constants[constant]
          .map(constant => constant.value)
          .map(constant => constants[constant]).flat(1)
          .map(constantClass => `lg:${constantClass}`)
      }

      if (constant == 'tablet') {
        return this.constants[constant]
          .map(constant => constant.value)
          .map(constant => constants[constant]).flat(1)
          .map(constantClass => `sm:${constantClass}`)
      }

      return this.constants[constant].map(constant => constant.value).map(constant => constants[constant]).flat(1)
    }).flat(1)

    return classes
  }
}
